module.exports = __webpack_public_path__ + "img/avatar-room.67bead38.svg";